import { combineReducers } from 'redux'
import code from './code'

const instantApp = combineReducers({
  code
})

export default instantApp



// WEBPACK FOOTER //
// ./src/reducers/index.js